export const canBeJSONParsed = (value: unknown): boolean => {
    try {
        JSON.parse(value as string);
        return true;
    } catch (error) {
        return false;
    }
};
